import React from 'react';
import ShowArticleStockProperties from "./ShowArticleStockProperties";
import { Box, Typography, Tooltip } from '@material-ui/core';
import LockIcon from "@mui/icons-material/Lock"
import useStyles from './ShowArticleStock.style';
import CheckIcon from '@mui/icons-material/Check';

const ShowArticleStock: React.FC<ShowArticleStockProperties> = ({
                                                    amount,
                                                    damagedAmount,
                                                    assignedAmount,
                                                    className = '',
                                                }) => {
    const classes = useStyles();
    const disponible = amount - assignedAmount;
    console.log("ShowArticleStock: amount", amount, "damagedAmount", damagedAmount, "assignedAmount", assignedAmount, "disponible", disponible);

    return (
        <div className={`${classes.card} ${className}`}>
            <Box className={classes.container}>
                {/* Total Principal */}
                <Box className={classes.main_content}>
                    <Typography className={classes.main_label}>Total en Inventario</Typography>
                    <Typography className={classes.main_value}>{amount + (damagedAmount ?? 0)}</Typography>
                </Box>

                {/* Desdobramento */}
                <Box className={classes.breakdown}>
                    <Box className={classes.breakdown_item}>
                        <Box className={classes.breakdown_label_with_icon}>
                            <CheckIcon className={classes.small_check_icon} />
                            <Typography className={classes.breakdown_label}>Disponible</Typography>
                        </Box>
                        <Typography className={classes.breakdown_value}>{disponible}</Typography>
                    </Box>
                    <Tooltip
                        title="Cantidad asignada en órdenes procesando o pendientes, no disponible para nuevas órdenes"
                        placement="top"
                        arrow
                    >
                        <Box className={classes.breakdown_item}>
                            <Box className={classes.breakdown_label_with_icon}>
                                <LockIcon className={classes.small_lock_icon} />
                                <Typography className={classes.breakdown_label}>Asignada</Typography>
                            </Box>
                            <Typography className={classes.breakdown_value}>{assignedAmount}</Typography>
                        </Box>
                    </Tooltip>
                </Box>
            </Box>
        </div>
    )
}
export default ShowArticleStock;
